import React, { useState } from "react";

// import "./retrieve_email.css";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import logo from "../../images/PPKM_Head.png";
import getEventController from "../Member/Controller/getEvent_controller";
import LoginController from "../Admin/Controller/login_controller.ts";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  const handleVerifyEmail = async (e) => {
    e.preventDefault();
    setError(null); // Reset error

    console.log(email);

    // Call the authentication function
    const data = await LoginController.verifyEmail(
      email,
    );

    if (data) {
      console.log(data.otp)
      console.log(data.userID)
      // If successful, navigate to the next page, e.g., OTP page or dashboard
      navigate("/admin/admin_reset_otp", {
        state: { email, userID:data.userID, sent_otp: data.otp },
      });
    } else {
      setError("Invalid email. Please try again.");
    }
  };

  return (
    <div className="retrieve-email-page">
      <div className="d-flex retrieve-email-container">
        <div className="retrieve-email-wrapper">
          <div className="login-title">
            <img className="web-login-logo" src={logo} alt="Logo" />
          </div>
          <p className="title_para">VERIFY EMAIL</p>
          <p className="re-span">
            Enter your registered secretariat email adress to verify.
          </p>
          <form className="retrieve-email-form" onSubmit={handleVerifyEmail}>
            <div className="fpf-row">
              <div className="mt-2">
                <label className="form-label re-form-label">
                  Email Address
                </label>
                <input
                  type="email"
                  placeholder="xx@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div>
              <Button className="reset-button" type="submit">
                Verify Email
              </Button>
            </div>
            <div>
              <Button
                className="reset-button"
                onClick={() => navigate("/admin/login")}
              >
                Return to Login Page
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
